import React from 'react';
import constants from './constants';
import ScheduleView from './ScheduleView';
import useGetSchedule from './useGetSchedule';

const ScheduleViewController = () => {
  const {
    weeksByPeriod,
    selectedDate,
    today,
    isCGT,
    dates,
    academicdates,
    meetings,
    virtualMeetings,
    currentWeek,
    slideDaySelected,
    isClassFlag,
    isLoadingSchedule,
    handlerNext,
    handlerSelectDate,
    slideChangeHandler,
    handleSelectAcademicCalendar
  } = useGetSchedule();
  return (
    <ScheduleView
      weeksByPeriod={weeksByPeriod}
      selectedDate={selectedDate}
      today={today}
      isCGT={isCGT}
      currentWeek={currentWeek}
      dates={dates}
      academicdates={academicdates}
      handlerNext={handlerNext}
      handlerSelectDate={handlerSelectDate}
      meetings={meetings}
      virtualMeetings={virtualMeetings}
      slideDaySelected={slideDaySelected}
      isClass={isClassFlag}
      // handlerSelectMobileSlide={handlerSelectMobileSlide}
      slideChangeHandler={slideChangeHandler}
      handleSelectAcademicCalendar={handleSelectAcademicCalendar}
      isLoadingSchedule={isLoadingSchedule}
      sectionHeader={constants.sectionHeader}
    />
  );
};

export default ScheduleViewController;
